import { ReactElement } from 'react'

import { Button, ButtonProps } from 'antd'
import { type TooltipPlacement } from 'antd/es/tooltip'
import classNames from 'classnames'

import { Icon } from 'components/core'
import { ToolTip } from 'components/ToolTip'

import * as styles from './styles.scss'

interface Props {
    active: boolean
    tooltipPlacement?: TooltipPlacement
}

const HomeDashboardIcon = ({
    active,
    tooltipPlacement = 'top',
    ...btnProps
}: Props & ButtonProps): ReactElement => (
    <ToolTip
        title={active ? 'This is your Home Dashboard' : 'Set as Home Dashboard'}
        placement={tooltipPlacement}
    >
        <div className={styles['home-icon-button']}>
            <Button
                shape="circle"
                type={active ? 'primary' : 'default'}
                className={classNames({
                    'fg-icon-btn-secondary': !active,
                })}
                {...btnProps}
            >
                <Icon name="HOME" size={12} />
            </Button>
        </div>
    </ToolTip>
)

export default HomeDashboardIcon
